// EHandover 所有 tab 的稳定标识。
// 这些值会被 tab 配置、total 刷新规则和页面内逻辑共同依赖，属于不要随便改的业务常量。
export const EHANDOVER_TAB_IDS = {
  PIN_TAB: 'PIN_TAB',
  SENT_TAB: 'SENT_TAB',
  CHECKLIST_TAB: 'CHECKLIST_TAB',
  OUTSTANDING_TAB: 'OUTSTANDING_TAB',
  COMPLETED_TAB: 'COMPLETED_TAB',
  SCHEDULE_TAB: 'SCHEDULE_TAB',
  MY_DRAFT_TAB: 'MY_DRAFT_TAB',
  DELETED_TAB: 'DELETED_TAB',
  NOTIFICATION_TAB: 'NOTIFICATION_TAB',
  REQUIRE_ACK_TAB: 'REQUIRE_ACK_TAB',
};

// checklist 的“未完成”状态组。
// 这个常量会影响 checklist/outstanding 的列表和 total 查询，不要在不了解状态映射时随意调整。
export const INCOMPLETE_CHECKLIST_STATUS = [2, 3, 4];

// checklist 的“已完成”状态组。
// 这个常量会影响 completed checklist 的列表和 total 查询。
export const COMPLETE_CHECKLIST_STATUS = [5];

// 列表接口统一重试次数。
// 这里只是页面内请求层的容错配置，不改变任何业务展示。
export const TAB_LIST_API_TOTAL_ATTEMPTS = 3;

// bitrix 列表接口默认需要返回的字段。
// 这组字段会直接影响 EHandover 各 tab 的列表渲染，属于高耦合配置。
export const FIELD_FROM_BITRIX_API = [
  'ID',
  'TITLE',
  'DESCRIPTION',
  'STATUS',
  'GROUP_ID',
  'CREATED_BY',
  'CREATED_DATE',
  'COMMENTS_COUNT',
  'DATE_START',
  'UF_TASK_WEBDAV_FILES',
  'PRIORITY',
  'MARK',
  'CHANGED_DATE',
];

// checklist 家族 tab 的集合。
// 只要目标 total 刷新里包含这个集合中的任意一个，就会触发 checklist family 的特殊联动逻辑。
export const CHECKLIST_FAMILY_TAB_IDS = [
  EHANDOVER_TAB_IDS.CHECKLIST_TAB,
  EHANDOVER_TAB_IDS.OUTSTANDING_TAB,
  EHANDOVER_TAB_IDS.COMPLETED_TAB,
];

// 参与“核心 total 联动”的 tab 集合。
// search / 公共筛选 / 自动刷新都会基于这组 tab 决定补刷哪些 title total。
export const CORE_TOTAL_TAB_IDS = [
  EHANDOVER_TAB_IDS.SENT_TAB,
  EHANDOVER_TAB_IDS.PIN_TAB,
  EHANDOVER_TAB_IDS.CHECKLIST_TAB,
  EHANDOVER_TAB_IDS.OUTSTANDING_TAB,
  EHANDOVER_TAB_IDS.COMPLETED_TAB,
  EHANDOVER_TAB_IDS.REQUIRE_ACK_TAB,
];

// 公共筛选变化后，各 active tab 需要额外补刷哪些其它 tab 的 total。
// 这里只定义“规则表”，不直接发请求；真正的请求逻辑仍在页面里消费这份配置。
export const SELECTIVE_TOTAL_REFRESH_MAP = {
  [EHANDOVER_TAB_IDS.SENT_TAB]: [
    EHANDOVER_TAB_IDS.PIN_TAB,
    EHANDOVER_TAB_IDS.CHECKLIST_TAB,
    EHANDOVER_TAB_IDS.OUTSTANDING_TAB,
    EHANDOVER_TAB_IDS.COMPLETED_TAB,
    EHANDOVER_TAB_IDS.REQUIRE_ACK_TAB,
  ],
  [EHANDOVER_TAB_IDS.PIN_TAB]: [
    EHANDOVER_TAB_IDS.SENT_TAB,
    EHANDOVER_TAB_IDS.CHECKLIST_TAB,
    EHANDOVER_TAB_IDS.OUTSTANDING_TAB,
    EHANDOVER_TAB_IDS.COMPLETED_TAB,
    EHANDOVER_TAB_IDS.REQUIRE_ACK_TAB,
  ],
  [EHANDOVER_TAB_IDS.REQUIRE_ACK_TAB]: [
    EHANDOVER_TAB_IDS.SENT_TAB,
    EHANDOVER_TAB_IDS.PIN_TAB,
    EHANDOVER_TAB_IDS.CHECKLIST_TAB,
    EHANDOVER_TAB_IDS.OUTSTANDING_TAB,
    EHANDOVER_TAB_IDS.COMPLETED_TAB,
  ],
  // CHECKLIST_TAB 刷新时会顺带更新 checklist 家族 total，所以这里只补刷家族外的核心 total。
  [EHANDOVER_TAB_IDS.CHECKLIST_TAB]: [
    EHANDOVER_TAB_IDS.SENT_TAB,
    EHANDOVER_TAB_IDS.PIN_TAB,
    EHANDOVER_TAB_IDS.REQUIRE_ACK_TAB,
  ],
  // CHECKLIST_TAB 与 OUTSTANDING/COMPLETED 是互斥显示的，所以这里只补另一个 sibling 和其它核心 total。
  [EHANDOVER_TAB_IDS.OUTSTANDING_TAB]: [
    EHANDOVER_TAB_IDS.SENT_TAB,
    EHANDOVER_TAB_IDS.PIN_TAB,
    EHANDOVER_TAB_IDS.COMPLETED_TAB,
    EHANDOVER_TAB_IDS.REQUIRE_ACK_TAB,
  ],
  [EHANDOVER_TAB_IDS.COMPLETED_TAB]: [
    EHANDOVER_TAB_IDS.SENT_TAB,
    EHANDOVER_TAB_IDS.PIN_TAB,
    EHANDOVER_TAB_IDS.OUTSTANDING_TAB,
    EHANDOVER_TAB_IDS.REQUIRE_ACK_TAB,
  ],
  // Scheduled / Deleted 做公共筛选时，需要额外补刷整组核心 total。
  [EHANDOVER_TAB_IDS.SCHEDULE_TAB]: CORE_TOTAL_TAB_IDS,
  [EHANDOVER_TAB_IDS.DELETED_TAB]: CORE_TOTAL_TAB_IDS,
};

// 首屏 total 预取和 total-only 请求统一只取 ID。
// 这是性能优化常量，专门用于“只更新标题 total，不更新列表内容”的场景。
export const INITIAL_TOTAL_SELECT = ['ID'];
